import React from "react";
import { BsAndroid2 } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import {
  MdArchitecture,
  MdDesignServices,
  MdKeyboardVoice,
} from "react-icons/md";
import { RiAppleFill, RiBlenderFill } from "react-icons/ri";
import { TfiVideoClapper } from "react-icons/tfi";
import { useContextHook } from "../../Context/ContextOPen";
import { Col, Container, Row } from "../../Tools/Grid-system";
import Accordion from "../Accordion/Accordion";
const Services = () => {
  const { swiperIndex, content, direction } = useContextHook();
  const dataServices = [
    {
      icon: CgWebsite,
      name: content.website,
      description: content.WebsiteDescription,
    },
    {
      icon: RiAppleFill,
      name: content.IOSApplication,
      description: content.IOSApplicationDescription,
    },
    {
      icon: BsAndroid2,
      name: content.AndroidApplication,
      description: content.AndroidApplicationDescription,
    },
    {
      icon: MdDesignServices,
      name: content.Design,
      description: content.DesignDescription,
    },

    {
      icon: MdKeyboardVoice,
      name: content.VoiceOver,
      description: content.VoiceOverDescription,
    },
    {
      icon: RiBlenderFill,
      name: content.Blender,
      description: content.BlenderDescription,
    },
    {
      icon: MdArchitecture,
      name: content.ArchitectureDesign,
      description: content.ArchitectureDesignDescription,
    },
    {
      icon: TfiVideoClapper,
      name: content.logo,
      description: content.logoDescription,
    },
  ];
  return (
    <div className="py-1">
      <Container>
        <h1
          style={{ direction: direction }}
          className={`text-4xl max-md:text-4xl font-bold mb-5 logo first-letter:text-Main transition-all ${
            swiperIndex === 2 ? "hero" : ""
          }`}
        >
          {content.Services}
        </h1>
        <Row
          className={`justify-center ${swiperIndex === 2 ? "services" : ""}`}
        >
          {dataServices.map((e, i) => (
            <Col key={i} xs={6} className="lg:hidden">
              <Accordion
                name={e.name}
                description={e.description}
                Icon={e.icon}
              />
            </Col>
          ))}
        </Row>
        <div
          style={{ direction: "ltr" }}
          className="h-full flex items-center justify-center max-lg:hidden"
        >
          <Row
            className={`justify-center ${swiperIndex === 2 ? "services" : ""}`}
          >
            {dataServices.map((e, i) => (
              <Col key={i} xs={6} md={4} lg={3} className=" relative">
                <Card description={e.description} name={e.name} Icon={e.icon} />
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Services;

const Card = ({ name, description, Icon, children }) => {
  return (
    <div
      className={`text-center h-full bg-Secondary border border-Main rounded-xl p-1 hover:scale-105 service hoverMain`}
    >
      {children}
      <Icon size={25} className="mx-auto my-2" />
      <h1 className="my-1 text-xl text-Main transition-all">{name}</h1>
      <p className="text-sm max-xxl:text-[14px] leading-6 px-2 pb-2">
        {description}
      </p>
    </div>
  );
};
